import React from 'react';

interface Props {
  isOpen: boolean;
  oemName: string;
  period: string;
  grandTotal: number;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

const formatRupiah = (n: number): string =>
  'Rp ' + n.toLocaleString('id-ID');

const MarkReviewedModal: React.FC<Props> = ({
  isOpen,
  oemName,
  period,
  grandTotal,
  onConfirm,
  onCancel,
  isLoading,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onCancel}
      />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6 z-10">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
            <i className="ri-checkbox-circle-line text-blue-600 text-[20px]" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              Mark as Correct
            </h2>
            <p className="text-sm text-gray-500 mt-0.5">
              Confirm that you have verified this invoice against the OEM PDF.
            </p>
          </div>
        </div>

        <div className="bg-gray-50 rounded-lg px-4 py-3 mb-5 space-y-1 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-500">OEM</span>
            <span className="font-medium text-gray-900">{oemName}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Period</span>
            <span className="font-medium text-gray-900">{period}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">FMS Net Total</span>
            <span className="font-semibold text-gray-900">{formatRupiah(grandTotal)}</span>
          </div>
        </div>

        <p className="text-xs text-gray-400 mb-5">
          If the underlying vehicle data changes after review, this period will automatically
          reset to Pending.
        </p>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className="flex-1 border border-gray-300 rounded-lg py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white rounded-lg py-2 text-sm font-medium disabled:opacity-50 transition-colors"
          >
            {isLoading ? (
              <>
                <i className="ri-loader-4-line animate-spin mr-1" />
                Confirming…
              </>
            ) : (
              'Confirm'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarkReviewedModal;
